import { request } from '../utils/request';

const API_RAG_BASE_PATH = '/ai/rag';

export const getIndexTimestamp = async (token) => {
	const response = await request({
		method: 'GET',
		url: `${API_RAG_BASE_PATH}/index/timestamps`,
		token,
	});

	if (response) {
		return response;
	}
};
